import * as actionTypes from './actionTypes';

export const changeUserAndProject = (requestData, callback) => ({
  type: actionTypes.CHANGE_USER_AND_PROJECT,
  requestData,
  callback,
});
